import React from "react";

/**
 * Large tappable radio card used for quiz option lists.
 * Behaves as a native radio via `role="radio"` and keyboard-friendly click.
 */
export function RadioCard({ value, label, checked, onSelect, testId }) {
    return (
        <button
            type="button"
            role="radio"
            aria-checked={checked}
            onClick={() => onSelect(value)}
            className="radio-card font-sans"
            data-testid={testId}
        >
            <span className="dot" aria-hidden />
            <span className="flex-1 leading-snug">{label}</span>
        </button>
    );
}
